export enum Themes {
    VITA_CONCIERGE = 'vc',
    VITA_STUDENT_CONCIERGE = 'vsc',
    HOUSE_OF_SOCIAL = 'hos',
}
